



















import {
  computed, defineComponent, ref,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';
import gql from 'graphql-tag';

import getHolidays from '@/gql/systemCalendar/getHolidays.gql';

import CommonFormWithSystemCalendarEditor from '@/components/Setting/CommonFormWithSystemCalendarEditor.vue';

const Index = defineComponent({
  components: {
    CommonFormWithSystemCalendarEditor,
  },
  setup() {
    const { router } = useRouter();

    // For Calendar
    const calendarStart = ref('');
    const calendarEnd = ref('');
    function handleDatesRender(event: any) {
      calendarStart.value = useFormat.date(event.view.activeStart).computerShortDate();
      calendarEnd.value = useFormat.date(event.view.activeEnd).computerShortDate();
    }
    function navigateToMonth(date: Date) {
      router.push({
        name: 'SettingSystemCalendarIndex',
        params: {
          date: useFormat.date(date).computerShortDate(),
        },
      });
    }
    const filterCalendarDueDate = computed(() => {
      let filterDueDateTemp;
      if (calendarStart.value !== '' && calendarEnd.value !== '') {
        filterDueDateTemp = {
          from: calendarStart.value,
          to: calendarEnd.value,
        };
      }
      return filterDueDateTemp;
    });
    const { result: getHolidaysResult, loading: getHolidaysLoading } = useQuery(getHolidays, computed(() => ({
      filterDateBetween: filterCalendarDueDate.value,
    })), () => ({ fetchPolicy: 'network-only' }));

    const holidays = useResult(getHolidaysResult, [], (data) => data.holidays.data);

    const editHoliday = ref({ id: -1, description: '' });
    function pendingToEditHoliday(obj: any) {
      editHoliday.value = obj.item;
    }
    const events = computed(() => holidays.value.map((elm: any) => {
      const color = 'green';
      return {
        id: elm.id,
        title: `${elm.description}`,
        start: elm.date,
        color,
      };
    }));

    const importHolidayMutation = useMutation(gql`mutation importHoliday { importHolidayFromBot }`, () => ({
      refetchQueries: ['getHolidays'],
    }));

    return {
      events,
      editHoliday,
      getHolidaysLoading,
      pendingToEditHoliday,
      handleDatesRender,
      navigateToMonth,

      importHolidayMutation,
    };
  },
});

export default Index;
